export const COLLECTIONS = {
  SETTINGS: 'settings',
  HOURS_DOC: 'business_hours',
  PUBLIC_CONFIG_DOC: 'public_config',
  EXCEPTIONS: 'exceptions',
  ANNOUNCEMENTS: 'announcements',
  MESSAGES: 'messages',
  EMAIL_QUEUE: 'email_queue',
  SMS_QUEUE: 'sms_queue',
  ADMIN_PUSH_TOKENS: 'admin_push_tokens',
} as const;

export const DR_COLLECTIONS = COLLECTIONS;

export const RTDB_PATHS = {} as const;

export const DATABASE_TYPE = {
  FIRESTORE: 'firestore',
  RTDB: 'realtime-database',
} as const;

export type CollectionName = (typeof COLLECTIONS)[keyof typeof COLLECTIONS];

export type DrCollectionName = CollectionName;


